import { gql } from "@apollo/client";

export type ReportFrequency = "daily" | "weekly" | "monthly";
export type ReportMonthAnchor = "first" | "last";

export type BranchReportSchedule = {
  id?: string;
  branch_id: number;
  frequency: ReportFrequency;
  weekday?: number | null;
  month_anchor?: ReportMonthAnchor | null;
  enabled: boolean;
};

export type GetReportSchedules = {
  getReportSchedules: BranchReportSchedule[];
};

export type GetReportSchedulesVariables = {
  branch_id: number;
};

export const GET_REPORT_SCHEDULES = gql`
  query GetReportSchedules($branch_id: Int!) {
    getReportSchedules(branch_id: $branch_id) {
      id
      branch_id
      frequency
      weekday
      month_anchor
      enabled
    }
  }
`;

export type SaveReportSchedules = {
  saveReportSchedules: BranchReportSchedule[];
};

export type SaveReportSchedulesVariables = {
  branch_id: number;
  schedules: {
    frequency: ReportFrequency;
    weekday?: number | null;
    month_anchor?: ReportMonthAnchor | null;
    enabled: boolean;
  }[];
};

export const SAVE_REPORT_SCHEDULES = gql`
  mutation SaveReportSchedules(
    $branch_id: Int!
    $schedules: [BranchReportScheduleInput!]!
  ) {
    saveReportSchedules(branch_id: $branch_id, schedules: $schedules) {
      id
      branch_id
      frequency
      weekday
      month_anchor
      enabled
    }
  }
`;
